import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import { API_URL } from '../config';

const API = API_URL;

const CATEGORY_COLORS = {
  'smartwatches':       { bg: 'linear-gradient(135deg,#f093fb,#f5576c)', shadow: 'rgba(245,87,108,0.35)' },
  'earphones':          { bg: 'linear-gradient(135deg,#4facfe,#00f2fe)', shadow: 'rgba(79,172,254,0.35)' },
  'speakers':           { bg: 'linear-gradient(135deg,#43e97b,#38f9d7)', shadow: 'rgba(67,233,123,0.35)' },
  'chargers':           { bg: 'linear-gradient(135deg,#fa709a,#fee140)', shadow: 'rgba(250,112,154,0.35)' },
  'powerbanks':         { bg: 'linear-gradient(135deg,#a18cd1,#fbc2eb)', shadow: 'rgba(161,140,209,0.35)' },
  'glass':              { bg: 'linear-gradient(135deg,#ffecd2,#fcb69f)', shadow: 'rgba(252,182,159,0.35)' },
  'accessories':        { bg: 'linear-gradient(135deg,#a1c4fd,#c2e9fb)', shadow: 'rgba(161,196,253,0.35)' },
  'phone-cases':        { bg: 'linear-gradient(135deg,#fd7043,#ff8a65)', shadow: 'rgba(253,112,67,0.35)' },
  'gaming-accessories': { bg: 'linear-gradient(135deg,#1a1a2e,#e94560)',  shadow: 'rgba(233,69,96,0.35)'  },
  'playstation':        { bg: 'linear-gradient(135deg,#003087,#0070d1)',  shadow: 'rgba(0,112,209,0.35)'  },
  'all':                { bg: 'linear-gradient(135deg,#cc0000,#ff2233)',   shadow: 'rgba(204,0,0,0.35)'   },
};

const CategoryFilter = ({ active, onChange }) => {
  const { t } = useLang();
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(`${API}/products/categories`)
      .then(r => setCategories(r.data.data))
      .catch(() => setCategories([]));
  }, []);

  return (
    <div className="cat-filter-v2">
      {categories.map(cat => {
        const key    = `cat_${cat.id.replace(/-/g, '_')}`;
        const label  = t(key) !== key ? t(key) : cat.label;
        const colors = CATEGORY_COLORS[cat.id] || CATEGORY_COLORS['all'];
        const isActive = active === cat.id;

        return (
          <button
            key={cat.id}
            className={`cat-chip-v2 ${isActive ? 'cat-chip-v2--active' : ''}`}
            style={isActive ? {
              background: colors.bg,
              boxShadow: `0 6px 20px ${colors.shadow}`,
            } : {}}
            onClick={() => onChange(cat.id)}
          >
            <span
              className="cat-chip-v2__icon-wrap"
              style={!isActive ? { background: colors.bg } : {}}
            >
              {cat.icon}
            </span>
            <span className="cat-chip-v2__label">{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default CategoryFilter;
